module.exports = __webpack_public_path__ + "img/telegram.7d03ad0d.svg";